import React from 'react';
import { BookOpenIcon } from '@heroicons/react/24/outline';
import { t } from '../../utils/translations';

/**
 * Marks a note that is a guided tablou, and is the way back into the structured editor.
 *
 * It carries the entry point rather than the row's pencil because a tablou must never be opened
 * in the plain note editor: that one writes the text only, which would leave the four layers
 * behind it stale and silently overwrite the typed text on the next structured save.
 */
const TabloulNoteBadge: React.FC<{ onOpen?: () => void }> = ({ onOpen }) => {
  const className =
    'inline-flex shrink-0 items-center gap-1 rounded-full bg-brand-50 px-2 py-0.5 text-[10px] font-semibold text-brand-700';

  if (!onOpen) {
    return (
      <span className={className}>
        <BookOpenIcon className="h-3 w-3" aria-hidden="true" />
        {t.tablou.badge}
      </span>
    );
  }

  return (
    <button
      type="button"
      onClick={onOpen}
      title={t.dashboard.todayFocus.openTablou}
      className={`${className} transition hover:bg-brand-100`}
    >
      <BookOpenIcon className="h-3 w-3" aria-hidden="true" />
      {t.tablou.badge}
    </button>
  );
};

export default TabloulNoteBadge;
